import styled from 'styled-components';
import { IoClose, IoSend } from 'react-icons/io5';

export const Background = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: ${(props) => (props.Show ? 'flex' : 'none')};
    align-items: center;
    justify-content: center;
    padding: 20px;
    background-color: rgba(0, 0, 0, 0.5); /* sombra de fundo */

    &:before {
        display: none;
    }

    @media screen and (max-width: 768px) {
        justify-content: flex-start;
    }
`;

export const Form = styled.form`
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    padding: 25px 35px;
    border-radius: 5px;
    background-color: var(--secondary-bg-color);
    gap: 40px;
    max-width: 50%;
    width: 100%;
    max-height: 95vh;
    @media screen and (max-width: 768px) {
        padding: 50px 20px 20px;
    }
    @media screen and (max-width: 1366px) {
        max-width: 50%;
    }
    @media screen and (max-width: 700px) {
        max-width: 80%;
    }
`;

export const Title = styled.h1`
    color: var(--primary-font-color);
    text-align: center;
    margin-bottom: 2%;
`;

export const Button = styled.button`
    border: none;
    border-radius: 5px;
    padding: 15px 20px;
    background-color: var(--main-color);
    color: var(--button-text-color);
    cursor: pointer;
    font-size: 16px;
    font-weight: 600;
    width: 100%;
    max-width: 45%;
    min-width: 180px;
    margin-bottom: 2%;
    &:hover {
        transform: scale(1.05);
        box-shadow: 0 10px 10px -10px rgba(0, 0, 0, 0.5);
    }
`;

export const CloseIcon = styled(IoClose)`
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
    font-size: 40px;
    transition: transform 0.2s;
    color: var(--second-auxiliary-color);

    &:hover {
        transform: scale(1.2);
    }
`;
export const RespostaContainer = styled.div`
    padding: 8px;
    overflow-y: auto;
    margin-bottom: 2px;
    border-radius: 6px;
    font-size: 14px;
    line-height: 1.4;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-end;
    gap: 5px;
    overflow-y: auto;
    height:fit-content;
`;

export const ContentWrapper = styled.div`
    height: 50vh;
    display: flex;
    flex-direction: row;
    gap: 30px;
    width: 100%;
    /* height: 100%; */
`;
export const InputMensagem = styled.textarea`
    width: 100%;
    padding: 0.6rem 1rem;
    padding-right: 50px;
    font-size: 1rem;
    border-right: none;
    border-radius: 6px;
    resize: none;
    overflow-y: auto;
    font-family: inherit;
    line-height: 1.4;
    height: auto;
    min-height: 40px;
    max-height: 120px;
    box-sizing: border-box;

    &::placeholder {
        color: #9ca3af;
    }

    &:focus {
        outline: none;
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.6;
    }
`;

export const SendMessage = styled.div`
    justify-content: center;
    display: flex;
    align-items: center;
    padding: 5px;
    width: 50px;
    min-height: 40px;
    border-radius: 0 6px 6px 0;
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    border-right: 1px solid rgb(59, 59, 59);
    border-left: none;
`;

export const IconSendMessage = styled(IoSend)`
    color: black;
    &:hover {
        color: rgb(26, 168, 50);
        cursor: pointer;
        transform: scale(1.1);
        transition:
            color 0.5s,
            transform 0.5s;
    }
`;

export const MessageCoontainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: ${(props) => (props.ladoMensagem ? 'flex-end' : 'flex-start')};
    .message {
        background-color: ${(props) => (props.ladoMensagem ? 'green' : 'rgb(119, 119, 119)')};
        padding: 10px 20px;
        border-radius: 6px;
        border: 1px solid rgb(158, 158, 158);
        width: fit-content;
        display: flex;
        flex-direction: column;
    }
`;

export const Message = styled.span`
    color: white;
    width: 100%;
`;
